import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogActions, MatDialogContent, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';

export interface DialogData {
	change: boolean;
}

@Component({
  selector: 'lib-infoadri',
	standalone: true,
  imports: [MatDialogContent, MatDialogActions, MatButtonModule],
  templateUrl: './infoadri.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './infoadri.component.scss'
})
export class InfoadriComponent {
	readonly dialogRef = inject(MatDialogRef<InfoadriComponent>);
	readonly dialogdata = inject<DialogData>(MAT_DIALOG_DATA as any);	// 'as any' tricks the compiler
	
	onClose(save: boolean) {
			this.dialogRef.close(save);
		}	
}
